/**
 * storageService.js
 * Centralized utility for handling encrypted localStorage operations using CryptoJS
 * matching the legacy Angular implementation precisely.
 */
import CryptoJS from 'crypto-js';

const SECRET_KEY = "d420dfe9ad4d05c671a5430d77d692cf";

const encrypt = (data) => {
    if (!data) return null;
    try {
        const stringData = typeof data === 'string' ? data : JSON.stringify(data);
        return CryptoJS.AES.encrypt(stringData, SECRET_KEY).toString();
    } catch (e) {
        console.error("Encryption failed", e);
        return data;
    }
};

const decrypt = (encryptedData) => {
    if (!encryptedData) return null;
    try {
        const decryptedBytes = CryptoJS.AES.decrypt(encryptedData, SECRET_KEY);
        const decryptedText = decryptedBytes.toString(CryptoJS.enc.Utf8);

        if (!decryptedText) {
            return encryptedData;
        }

        try {
            return JSON.parse(decryptedText);
        } catch {
            return decryptedText;
        }
    } catch (e) {
        return encryptedData; // fallback
    }
};

const createStorageHandler = (storage) => ({
    setItem: (key, value) => {
        if (value === null || value === undefined) {
            storage.removeItem(key);
            return;
        }
        storage.setItem(key, encrypt(value));
    },

    getItem: (key) => {
        const encryptedValue = storage.getItem(key);
        return decrypt(encryptedValue);
    },

    removeItem: (key) => {
        storage.removeItem(key);
    },

    clear: () => {
        storage.clear();
    }
});

const storageService = createStorageHandler(localStorage);
export const sessionStorageService = createStorageHandler(sessionStorage);

export default storageService;

